import { useNavigate } from "react-router-dom";
import { Radio, ArrowLeft, Home, Search, Headphones } from "lucide-react";
import Header from "../components/Header";
import SEO from "../components/SEO";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <SEO title="404 — Page Not Found" description="The page you're looking for doesn't exist." noindex={true} />
      <Header />
      <div className="flex items-center justify-center min-h-[80vh] px-6">
        <div className="text-center max-w-lg">
          <div className="relative mb-8">
            <span className="text-[120px] sm:text-[160px] font-black text-white/[0.03] leading-none select-none block">404</span>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-20 h-20 bg-purple-500/10 border border-purple-500/20 rounded-full flex items-center justify-center">
                <Radio className="w-10 h-10 text-purple-400" />
              </div>
            </div>
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold mb-3" data-testid="404-heading">Off the Air</h1>
          <p className="text-white/50 mb-8 text-sm sm:text-base">
            The page you're looking for doesn't exist or has been moved. Let's get you back on track.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <button
              onClick={() => navigate("/")}
              className="flex items-center gap-2 bg-purple-500 hover:bg-purple-600 text-white px-6 py-3 rounded-xl font-semibold transition w-full sm:w-auto justify-center"
              data-testid="404-home-btn"
            >
              <Home className="w-4 h-4" /> Go Home
            </button>
            <button
              onClick={() => navigate("/discover")}
              className="flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 text-white px-6 py-3 rounded-xl font-semibold transition w-full sm:w-auto justify-center"
              data-testid="404-discover-btn"
            >
              <Headphones className="w-4 h-4" /> Discover Stations
            </button>
          </div>
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-1.5 text-white/40 hover:text-white/70 text-sm transition mx-auto mt-6"
            data-testid="404-back-btn"
          >
            <ArrowLeft className="w-3.5 h-3.5" /> Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
